<template>
  <!-- Visão em Grid -->
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="items"
    item-key="IdAtividade"
    class="elevation-1"
    rows-per-page-text="Registros"
    select-all
    :pagination.sync="pagConfigHelpdesk"
    :loading="loading"
    :search="searchTerm"
    no-data-text="Nenhum registro encontrado"
    @update:pagination="updatePagination"
  >
    <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
    <template v-slot:items="props">
      <tr
        :active="props.selected"
        class="cursor-pointer atividade"
        :class="statusAtividade(props.item.Status)"
        @dblclick="editItem(props.item.IdAtividade)"
        @click="props.selected = !props.selected"
      >
        <td>
          <v-checkbox :input-value="props.selected" primary color="primary" hide-details></v-checkbox>
        </td>
        <td>{{ props.item.Descricao }}</td>
        <td>
          <!-- <span 
            v-for="cliente in atividadeClientes(props.item.IdAtividade)" 
            :key="cliente.IdCliente"
          >{{ cliente.Fantasia }}<br>
          </span> -->
          <span v-if="props.item.Clientes">{{ props.item.Clientes }}</span>
        </td>
        <td>
          <span v-if="props.item.Tags">{{ props.item.Tags }}</span>
        </td>
        <td>
          <span v-if="props.item.Workflow">{{ props.item.Workflow }}</span>
        </td>
        <td>
          <v-avatar size="32" :color="statusAtividade(props.item.Status)">
            <span class="white--text">{{ props.item.Status[0] }}</span>
          </v-avatar>
        </td>
        <td>
          <v-icon small>access_time</v-icon>
          {{ duracaoAtividade(props.item.Duracao) }}
        </td>
        <td>{{ moment.utc(props.item.DataPrevisao).format('DD/MM/YYYY') }}</td>
        <td>{{ props.item.TipoAtividade }}</td>
        <td>{{ props.item.Responsavel }}</td>
        <td><v-chip dark :color="props.item.Cor">{{ props.item.Situacao }}</v-chip></td>
        <td>
          <v-progress-linear
            v-model="props.item.Progresso"
            height="20"
            :value="props.item.Progresso"
            :color="progressColor(props.item.Progresso)"
            class="text-xs-center"
          >{{ props.item.Progresso }}%</v-progress-linear>
        </td>
        <td>
          <v-progress-circular
            :size="36"
            :value="props.item.ValorGut || 0"
            :color="matrizGutColor(props.item.ValorGut || 0)"
          >
            <span class="font-weight-medium">{{ props.item.ValorGut || 0 }}</span>
          </v-progress-circular>
        </td>
        <td>
          <v-progress-circular
            v-if="props.item.ValorNps !== null && props.item.ValorNps !== undefined"
            :size="36"
            :value="npsValue(props.item.ValorNps)"
            :color="npsColor(props.item.ValorNps)"
          >
            <span class="font-weight-medium">{{ props.item.ValorNps }}</span>
          </v-progress-circular>
        </td>
      </tr>
    </template>
    <template v-slot:no-results>
      <v-alert
        :value="true"
        color="error"
        icon="warning"
      >Pesquisa por "{{ searchTerm }}" não encontrou resultados.</v-alert>
    </template>
    <template
      v-slot:pageText="props"
    >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
    <template v-slot:footer v-if="filtroAtivo">
      <td :colspan="headers.length">
        <strong>Filtro Ativo: {{ filtroAtivo }}</strong>
      </td>
    </template>
  </v-data-table>
  <!-- Fim Visão em Grid -->
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { matrizGutHelper } from '@/utils/matrizGutHelper';
import { npsHelper } from '@/utils/npsHelper';

export default {
  props: ["items", "searchTerm", "loading", "forcePagConfigDefault", "filtroAtivo"],
  name: "Grid",
  data: () => ({
    headers: [
      { text: "Descrição", value: "Descricao" },
      { text: "Clientes", value: "Clientes" },
      { text: "Tags", value: "Tags" },
      { text: "Workflow", value: "Workflow" },
      { text: "Status", value: "Status" },
      { text: "Duração", value: "Duracao" },
      { text: "Previsão", value: "DataPrevisao" },
      { text: "Tipo", value: "TipoAtividade" },
      { text: "Responsável", value: "Responsavel" },
      { text: "Situação", value: "Situacao" },
      { text: "Progresso", value: "Progresso" },
      { text: "GUT", value: "ValorGut" },
      { text: "NPS", value: "ValorNps" },
    ],
    pagConfigHelpdesk: {
      descending: true,
      page: 1,
      rowsPerPage: 10, // -1 for All"
      sortBy: "DataPrevisao"
    }
  }),
  computed: {
    ...mapGetters(["atividades", "atividadesSelected", "allAtividadeClientes"]),
    selected: {
      // getter
      get: function () {
        return this.atividadesSelected;
      },
      set: function (value) {
        this.selectAtividades(value);
      }
    }
  },
  methods: {
    ...mapActions(["fetchAtividadesCliente", "selectAtividades", "fetchAllAtividadeClientesNode"]),
    ...mapMutations(["showNotification", "closeNotification"]),
    editItem(id) {
      // this.searchTerm
      //   ? localStorage.setItem("searchTerm", this.searchTerm)
      //   : localStorage.setItem("searchTerm", "");
      localStorage.setItem('pagConfigHelpdesk', JSON.stringify(this.pagConfigHelpdesk));
      this.$router.push({ name: "altera atividade", params: { id } });
    },
    editItemSelected() {
      if (this.selected.length) {
        // this.searchTerm
        //   ? localStorage.setItem("searchTerm", this.searchTerm)
        //   : localStorage.setItem("searchTerm", "");
        localStorage.setItem("pagConfigHelpdesk", JSON.stringify(this.pagConfigHelpdesk));
        let id = this.selected[this.selected.length - 1].IdAtividade;
        this.$router.push({ name: "altera atividade", params: { id } });
      } else {
        this.showNotification({
          text: "Selecione uma atividade para alterar.", status: 'error'
        });
      }
    },
    npsValue(valor) {
      return npsHelper.npsValue(valor);
    },
    npsColor(valor) {
      return npsHelper.npsColor(valor);
    },
    matrizGutColor(valor) {
      return matrizGutHelper.matrizGutColor(valor);
    },
    progressColor(progresso) {
      if (progresso >= 0 && progresso <= 30) return "error";
      if (progresso >= 30 && progresso < 100) return "warning";
      if (progresso == 100) return "success";
    },
    statusAtividade(status) {
      if (status.includes('P')) return "#263238";
      if (status.includes('F')) return "#1976d2";
      if (status.includes('C')) return "#bdbdbd";
    },
    duracaoAtividade(tempo) {
      if (tempo) {
        // let inicio = this.moment([1899, 11, 30]);
        // Verifica se o ano da tempo é 1899 == ano padrão DELPHI
        // Caso não, estaremos usando o ano padrão JavaScript == 1970
        const anoDelphi = new Date(tempo).getFullYear() == 1899;
        let inicio = anoDelphi ? this.moment([1899, 11, 30]): new Date(1970, 0, 1, 0, 0, 0);
        let final = this.moment(tempo);
        // Pega a diferença entre as datas em millisegundos
        let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
        let duration = this.moment.duration(ms);
        let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
        if (duracaoFinal.length === 4) duracaoFinal = `0${duracaoFinal}`;
        return duracaoFinal;
      } else {
        return '00:00';
      }
    },
    atividadeClientes(idAtividade) {
      return this.allAtividadeClientes.filter(atividadeCliente => atividadeCliente.IdAtividade === idAtividade);
    },
    salvaConfigPesquisa() {
      localStorage.setItem("pagConfigHelpdesk", JSON.stringify(this.pagConfigHelpdesk));
    },
    recuperaConfigPesquisa() {
      // Verifica se existe no localStorage o item pagConfigHelpdesk salvo anteriormente
      if (localStorage.getItem('pagConfigHelpdesk')) {
        this.pagConfigHelpdesk = JSON.parse(localStorage.getItem('pagConfigHelpdesk'));
      }
    },
    updatePagination() {
      this.salvaConfigPesquisa();
    },
  },
  async created() {
    if (!this.forcePagConfigDefault) {
      this.recuperaConfigPesquisa();
    }
    // await this.fetchAllAtividadeClientesNode();
  }
};
</script>

<style>
</style>